module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Nacht im Forst")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wald und Weide liegen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ntief in Nacht gehüllt;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nKauz und Eule fliegen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund es schläft das Wild.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Schwarze Tannen heben"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nstumm sich himmelan;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nalles ohne Leben"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nrings im weiten Tann.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mondesampel steiget"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nübers Wipfelmeer;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch im Glanze schweiget"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nalles wie bisher.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Licht und Dunkel schlingen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nlautlos Hand in Hand,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund du scheinst zu dringen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nin ein Fabelland. "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page32",
      "title": "wedi/Konmax"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2250ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0018.vue
// module id = 108
// module chunks = 0